'use client';

import { PropsWithChildren } from 'react';
import { ChakraProvider } from '@chakra-ui/react';

import { ModeProvider } from './snippets';
import { system } from './theme';

// These fonts should be imported in the same file that we import `ChakraProvider` based on their documentation
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

export function ThemeProvider({ children }: PropsWithChildren<{}>) {
  return (
    <ChakraProvider value={system}>
      <ModeProvider>{children}</ModeProvider>
    </ChakraProvider>
  );
}
